<div class="chatDeletionConfirmation_container">
    <h1 mat-dialog-title>{{"chatView.confirmDeletionHeader" | translate}}</h1>
    <div mat-dialog-content>
      {{"chatView.chatDeletionConfirmation" | gender | translate}} <strong>{{ chatName }}</strong>?
    </div>
    <div class="chatDeletionConfirmation_actionsContainer">
      <button mat-raised-button class="chatDeletionConfirmation_button" (click)="onCancel()">{{"chatView.confirmDeletionActionCancel" | translate}}</button>
      <button mat-raised-button class="chatDeletionConfirmation_button" color="warn" (click)="onConfirm()">{{"chatView.confirmDeletionActionDelete" | translate}}</button>
    </div>
</div>
